import { User } from "@/commons/interface/project/user"
import { StdResponse, bimAxios } from "@/config/axios"



export function getUsers(params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/users`, {
        params: {
            ...params,
        }
    })
}

export function getUsersByProjectUuid(projectUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/projects/${projectUuid}/user-list`, {
        params: {
            ...params,
        }
    })
}

export function addUser(user: User, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/users`, user, {
        params: {
            ...params,
        }
    })
}


export function findUserDetail(userUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/users/${userUuid}`, {
        params: {
            ...params,
        }
    })
}

export function updateUser(userUuid: string, data: User, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.put(`/users/${userUuid}`, data, {
        params: {
            ...params,
        }
    })
}

export function getUserByLogin(username: string, password: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/users/login`, null, {
        params: {
            ...params,
            username: username,
            password: password,
        }
    })
}

export function getUsersCheckLogin(params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/users/check-login`, {
        params: {
            ...params,
        }
    })
}